import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = [ 'input', 'button' ]

  connect() {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      for (let input of this.inputTargets) {
        let value = input.value
        input.defaultValue = ''
        input.value = value
      }
    }
    for (let button of this.buttonTargets) {
      button.innerHTML = ''
    }
  }

  clear () {
    for (let input of this.inputTargets) {
      input.value = null
    }
  }
}

